export default function AdminListToolbar({ draft, onDraftChange, onSearch, placeholder, testid, total, shown }) {
  return (
    <div className="px-4 sm:px-6 py-3 border-b border-[var(--zc-border)] flex flex-col sm:flex-row sm:items-center gap-3 justify-between">
      <div className="flex flex-1 gap-2 min-w-0 max-w-md">
        <input
          value={draft}
          onChange={(e) => onDraftChange(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && onSearch()}
          placeholder={placeholder}
          className="zc-input h-9 px-3 text-sm flex-1 min-w-0"
          data-testid={`${testid}-input`}
        />
        <button type="button" onClick={onSearch} className="px-3 h-9 zc-btn-ghost text-xs shrink-0" data-testid={`${testid}-btn`}>
          Search
        </button>
      </div>
      {total != null && (
        <div className="text-xs text-[var(--zc-text-3)] shrink-0">
          Showing {shown}{total > shown ? ` of ${total}` : ""}
        </div>
      )}
    </div>
  );
}
